module.exports = "/static-assets/_next/static/images/img-e47b52fe21-d6308bfe4ce7f5a00c5375332aba7c99.webp";